export default "__VITE_ASSET__5fUbYqhW__"